/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_is_105_115 as Componente_is_105_115,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Wo as Wo,
  rec_Xr as Xr,
  rec_as as as,
  rec_es as es,
  rec_h as h,
  rec_os as os,
  rec_ra as ra,
  rec_rs as rs,
  rec_ss as ss,
} from "../../runtime/index.jsx";
export function ProveedorAvisos(e) {
  let t = (0, ReactCompiler.c)(14),
    { children: n } = e,
    r;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((r = []), (t[0] = r))
    : (r = t[0]);
  let [i, a] = (0, React.useState)(r),
    [o, s] = (0, React.useState)(null),
    c = (0, React.useRef)(1),
    l;
  t[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((l = (e) => {
        a((t) => t.filter((t) => t.id !== e));
      }),
      (t[1] = l))
    : (l = t[1]);
  let u = l,
    f;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((f = (e, t, n) => {
        let r = t === void 0 ? `ok` : t,
          i = n === void 0 ? null : n;
        c.current += 1;
        let o = c.current;
        return (
          a((t) => [
            ...t.slice(-2),
            {
              id: o,
              texto: e,
              tipo: r,
              deshacer: i,
            },
          ]),
          r === `error`
            ? (es(`error`), rs(`error`))
            : setTimeout(
                () => a((e) => e.filter((e) => e.id !== o)),
                i ? 7e3 : 4e3,
              ),
          o
        );
      }),
      (t[2] = f))
    : (f = t[2]);
  let p = f,
    m;
  t[3] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((m = (e, t) => {
        p(e, `ok`, t);
      }),
      (t[3] = m))
    : (m = t[3]);
  let _ = m,
    v;
  t[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((v = (e, t, n) => {
        (s({
          texto: e,
          detalle: t,
          posicion: n === void 0 ? `centro` : n,
        }),
          es(`exito`),
          rs(`exito`));
      }),
      (t[4] = v))
    : (v = t[4]);
  let y = v,
    b;
  t[5] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((b = {
        mostrar: p,
        ok: (e) => p(e, `ok`),
        error: (e) => p(e, `error`),
        info: (e) => p(e, `info`),
        logro: y,
        conDeshacer: _,
      }),
      (t[5] = b))
    : (b = t[5]);
  let x = b,
    S;
  t[6] === o
    ? (S = t[7])
    : ((S = o && (
        <Componente_is_105_115
          texto={o.texto}
          detalle={o.detalle}
          posicion={o.posicion}
          onDone={() => s(null)}
        />
      )),
      (t[6] = o),
      (t[7] = S));
  let C;
  t[8] === i
    ? (C = t[9])
    : ((C =
        i.length > 0 &&
        (0, h.createPortal)(
          <div
            className={`pointer-events-none fixed inset-x-0 bottom-0 z-[60] flex flex-col items-center gap-2 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]`}
            children={i.map((e) => {
              let t = as[e.tipo] ?? Xr;
              return (
                <div
                  key={e.id}
                  role={`status`}
                  className={`animar-entrada pointer-events-auto flex w-full max-w-md items-start gap-2 rounded-2xl border px-3 py-2.5 text-sm text-(--text-h) shadow-(--shadow) ${os[e.tipo] ?? os.info}`}
                  children={[
                    (0, JSXRuntime.jsx)(t, {
                      className: `mt-0.5 h-4 w-4 shrink-0 ${ss[e.tipo] ?? ss.info}`,
                    }),
                    <span className={`min-w-0 flex-1`} children={e.texto} />,
                    e.deshacer && (
                      <button
                        type={`button`}
                        onClick={() => {
                          (u(e.id), e.deshacer());
                        }}
                        className={`shrink-0 rounded-full px-2 py-1 text-sm font-medium text-(--accent) transition duration-150 ease-(--curva) hover:bg-(--accent-bg) active:scale-[0.95]`}
                        children={`Deshacer`}
                      />
                    ),
                    <button
                      type={`button`}
                      onClick={() => u(e.id)}
                      aria-label={`Cerrar aviso`}
                      className={`shrink-0 rounded-lg p-1.5 text-(--text) transition hover:text-(--text-h)`}
                      children={(0, JSXRuntime.jsx)(ra, {
                        className: `h-4 w-4`,
                      })}
                    />,
                  ]}
                />
              );
            })}
          />,
          document.body,
        )),
      (t[8] = i),
      (t[9] = C));
  let w;
  return (
    t[10] !== n || t[11] !== S || t[12] !== C
      ? ((w = <Wo.Provider value={x} children={[n, S, C]} />),
        (t[10] = n),
        (t[11] = S),
        (t[12] = C),
        (t[13] = w))
      : (w = t[13]),
    w
  );
}
